import { hideToast } from "../../redux/guest-slices/other.slice"
import { setCurrectChat } from "../../redux/user-slices/socket.slice"
import { Alert, Slide, Snackbar } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

const SlideComponet = (props) => (
  <Slide {...props} direction="left" />
)

function Toaster() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { toast } = useSelector(state => state.otherSlice)

  const handleClose = () => {
    dispatch(hideToast())
  }

  return (
    <Snackbar
      open={toast?.show}
      onClose={handleClose}
      autoHideDuration={5000}
      TransitionComponent={SlideComponet}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        variant="filled"
        onClose={(e) => {
          e.stopPropagation();
          handleClose();
        }}
        severity={toast?.type || toast?.severity || "success"}
        sx={toast?.onClickPath ? { cursor: 'pointer' } : {}}
        onClick={() => {
          if (toast?.onClickPath) {
            if (toast?.onClickState) {
              dispatch(setCurrectChat(toast.onClickState));
            }
            navigate(toast.onClickPath, { state: "test" });
            handleClose();
          }
        }}
      >{toast?.message || toast?.msg}
      </Alert>
    </Snackbar>
  )
}

export default Toaster